// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__z2rxI","list":"PatternAutocomplete_list__3tQ4y"};